import { render, staticRenderFns } from "./EventBase.vue?vue&type=template&id=772944f9&"
import script from "./EventBase.vue?vue&type=script&lang=js&"
export * from "./EventBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports